import React from 'react';
import { Button, Form, Grid, List, Segment } from 'semantic-ui-react';
import { Field, reduxForm, reset } from 'redux-form';
import { connect } from 'react-redux';
import { cloneDeep } from 'lodash';

import PhotoBoothModal from '../../../../../../../containers/PhotoBoothModal';
import { Tech3Input, Tech3InputTimeWithIcon } from '../../../../../../../components/FormElements';
import { closeAllModals } from '../../../data/fileImport/modalActions';
import { updateLogSession } from '../../../data/fileImport/sessionsActions';

const logSessionFormName = 'logSessionFormModal';

class SessionLogs extends React.Component {
  /**
   * Submit SessionLogForm
   *
   */
  SubmitSessionLogForm(values) {
    const session = cloneDeep(this.props.session);

    // update session : projectId, conditionId, Status, participant, started,
    // à ajuster en fonction de l'api
    session.start_time = values.startTime;
    session.end_time = values.endTime;
    // session.humidity        = values.humidity;
    // session.temperature     = values.temperature;

    // session.projectId       = this.props.projectId;
    this.props.dispatch(updateLogSession(session));

    // Close modal
    this.props.dispatch(closeAllModals());
    // reset form values
    this.props.dispatch(reset(logSessionFormName));
  }

  render() {
    if (!this.props.session) return null;
    return (
      <PhotoBoothModal {...this.props}>
        <Form
          className="sessionLog__Form"
          onSubmit={this.props.handleSubmit(this.SubmitSessionLogForm.bind(this))}
        >
          <h3>Log Session</h3>
          <Segment className="sessionLog__information">
            <h4 className="section-title">Session information</h4>
            <Grid columns={3}>
              <Grid.Row>
                <Grid.Column>
                  <Field
                    label="Start Time"
                    name="startTime"
                    type="time"
                    component={Tech3InputTimeWithIcon}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    label="End Time"
                    name="endTime"
                    type="time"
                    component={Tech3InputTimeWithIcon}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
          <Segment className="sessionLog__localisation">
            <h4 className="section-title">Localisation information</h4>
            <Grid columns={3}>
              <Grid.Row>
                <Grid.Column>
                  <Field
                    label="Temperature (C)"
                    name="temperature"
                    type="text"
                    component={Tech3Input}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field label="Humidity (%)" name="humidity" type="text" component={Tech3Input} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
          <Segment className="sessionLog__participant-data data-participant-section">
            <h4 className="section-title">Participant Data</h4>
            <Grid columns={3}>
              <Grid.Row>
                <Grid.Column>
                  <Field
                    label="Find user by email in system list"
                    name="participantEmail"
                    type="email"
                    component={Tech3Input}
                    disabled
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <List className="age-sex">
                    <List.Item className="age">
                      <label>Age</label>
                      <br />
                      <span className="value">{this.props.initialValues.participantAge}</span>
                    </List.Item>
                    <List.Item className="sex">
                      <label>Sexe</label>
                      <br />
                      <span className="value">{this.props.initialValues.participantGender}</span>
                    </List.Item>
                  </List>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
          <div className="submit-btn-container">
            <Button className="green right floated">
              <i className="check square outline icon" /> OK complete
            </Button>
          </div>
        </Form>
      </PhotoBoothModal>
    );
  }
}

const logSessionForm = reduxForm({
  form: logSessionFormName,
  enableReinitialize: true
})(SessionLogs);

export default connect(state => ({
  session: state.projects.single.fileImport.sessions.find(
    session => session.id === state.projects.single.fileImport.modals.logSession.dataTreeId
  ),
  sessions: state.projects.single.fileImport.sessions,
  initialValues: state.projects.single.fileImport.intialValuesLogSessionForm
}))(logSessionForm);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/modals/SessionLogs.js